import { useState, useContext } from "react";

import { AuthContext } from "../contexts/AuthContext";
import DataTable from "react-data-table-component";
import TableLoader from "./TableLoader";

import useUserNotifications from "../hooks/useUserNotifications";

import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

import { NotificationIcons, NotificationContent } from "./NotificationRow";

const LabourerNotificationTable = () => {
  const { user } = useContext(AuthContext);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);

  const { data, isLoading } = useUserNotifications(
    { userId: user?._id, page, perPage },
    { refreshInterval: 10 * 1000 }
  );

  const notifications = data?.notifications;
  const notificationCount = data?.count;

  const handlePageChange = page => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      grow: 2,
      cell: (row) => (
        <div className='flex items-center gap-2'>
          <NotificationIcons notificationType={row.type} />
          <span>{row.title}</span>
        </div>
      )
    },
    {
      name: "Date",
      selector: (row) => row.createdAt,
      format: (row) => formatDateToSydneyTimeZone(row.createdAt)
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={notifications}
      highlightOnHover
      striped
      pointerOnHover
      expandableRows
      expandableRowsComponent={NotificationContent}
      pagination
      paginationServer
      progressPending={isLoading}
      progressComponent={<TableLoader />}
      paginationTotalRows={notificationCount}
      paginationRowsPerPageOptions={[5, 10, 20]}
      paginationPerPage={perPage}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handlePerRowsChange}
    />
  );
}

export default LabourerNotificationTable;
